import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import '@rmwc/chip/styles';
import React, { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import toast, { Toaster } from 'react-hot-toast';
import DropDownMultiSelectMFACustom from '../../components/dropDownMultiSelectMFACustom'
import BrandCategoryDialogueBox from '../../components/brandCategoryDialogueBox';
import ChannelCategoryFormModal from '../../components/channelCategoryFormModal';
import TableMFAChannelCategory from '../../components/tableMFAChannelcategory';
import { BASE_URL, CHANNEL_CATEGORY_MAPPINGS, BRAND_CATEGORY_MAPPINGS, FILTERS, INPUT_SUGGESTIONS, INPUT_FORMS, MFA, DELETE, EXPORT } from '../../constant/apiEndpoints';
import { channelCategoryInitailColumnsForm } from '../../constant/constants';
import { channelSuggestionData } from '../../constant/utils';
import APIService from '../../services/APIService';
const tableHeadColour = '#F2F2F2';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const initialColumns = channelCategoryInitailColumnsForm

//Material UI Styles
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: tableHeadColour,
        color: theme.palette.common.black,
        fontWeight: 600,
        cursor: 'pointer'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({

}));
//Material UI Styles


const Consolidated3 = (props) => {

    const [adminIds, setAdminIds] = useState(props.adminIds);
    const [homeOOHList, setHomeOOHList] = useState([]);
    const [tradeChannelList, setTradeChannelList] = useState([]);
    const [subtradeChannelList, setSubtradeChanelList] = useState([]);
    const [selectedHomeOOHList, setSelectedHomeOOHList] = useState([]);
    const [selectedTradeChannelList, setSelectedTradeChannelList] = useState([]);
    const [selectedSubtradeChannelList, setSelectedSubtradeChannelList] = useState([]);
    const [selectedList, setSelectedList] = useState([]); //Button Handle
    const [columns, setColumns] = useState(initialColumns); //Columns Handle
    const [channelCategoryMappingList, setChannelCategoryMappingList] = useState([]); //Table Data Handle
    const [dropDownTimer, setDropDownTimer] = useState(0);
    const [loading, setLoading] = useState(true);
    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [selectedIdToEdit, setSelectedIdToEdit] = useState();
    const [openDeleteDialogueBox, setOpenDeleteDialogueBox] = useState(false);
    const [suggestions, setSuggestions] = useState(channelSuggestionData);

    const setSelectedListInParent = (value) => {
        setSelectedList(value)
    }

    const handleIsFormModalOpen = (value) => {
        setIsFormModalOpen(value);
        setSelectedIdToEdit();
    }

    const handleDeleteDialogueBox = () => {
        setOpenDeleteDialogueBox(!openDeleteDialogueBox)
    }

    const handleDeleteButton = () => {
        setOpenDeleteDialogueBox(true)
    }

    //Support Function For Filter List
    const createStringFromObjectList = (objs) => {
        let newString = ""
        for (var i = 0; i < objs.length; i++) {
            if (newString.length === 0) {
                newString = objs[i].value
            } else {
                newString = newString + "," + objs[i].value
            }
        }
        return encodeURIComponent(newString)
    }

    //AJAX Call To Load Channel Mapping List
    const loadChannelCategoryMappingAPICall = async (selectedHomeFilter = "", selectedTradeChannelFilter = "", selectedSubtradeChannelFilter = "" ) => {
        let url = BASE_URL + INPUT_FORMS + MFA + CHANNEL_CATEGORY_MAPPINGS + `?selected_form=${props.formId}` + selectedHomeFilter + selectedTradeChannelFilter + selectedSubtradeChannelFilter
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in channel exlusion list API", response.results.message)
        } else {
            // if (response.results.length > 0) {
            // const transformedData = response.results.map(({ id, title }) => ({ label: title, value: id }));
            setChannelCategoryMappingList(response.results);
            // setBrandCategoryListReference(response.results);
            // }
        }
        setLoading(false);
    }
    const loadChannelSuggestion = async () => {
        let url = BASE_URL + INPUT_FORMS + MFA + CHANNEL_CATEGORY_MAPPINGS + INPUT_SUGGESTIONS + `?selected_form=${props.formId}`
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in Channel List API", response.results.message)
        } else {
            if (response.results) {
                setSuggestions(response.results);
            }
        }
    }
    const handleDelete = async (comment) => {
        let url = BASE_URL + INPUT_FORMS + MFA + CHANNEL_CATEGORY_MAPPINGS + DELETE
        let body = {
            "form_id": props.formId,
            "comment": comment,
            "ids": selectedList.map((ele) => { return ele.channel_id })
        }
        let response = await new APIService().delete(url, body)
        if (response.error) {
            if (response.status == 400) {
                if (response.results.message.includes("This field may not be blank.")) {
                    toast.error('Comment is required!', { position: 'top-center', className: 'toast-popup', duration: 2000 });
                } else {
                    toast.error('Something went wrong.', { position: 'top-center', className: 'toast-popup', duration: 2000 });
                }
            }
        } else {
            toast.success('Data deleted successfully.', { position: 'top-center', className: 'toast-popup', duration: 1000 });
            loadChannelCategoryMappingList(true, selectedHomeOOHList, selectedTradeChannelList, selectedSubtradeChannelList);
            handleDeleteDialogueBox();
            setSelectedList([])
        }
    }
    const handleExportButton = async () => {

        let selectedHomeFilter = getHomeOOHFilter(null)

        let selectedTradeChannelFilter = getTradeChannelFilter(null)

        let selectedSubtradeChannelFilter = getSubtradeChannelFilter(null)

        let url = BASE_URL + INPUT_FORMS + MFA + CHANNEL_CATEGORY_MAPPINGS + EXPORT + `?selected_form=${props.formId}` + selectedHomeFilter + selectedTradeChannelFilter + selectedSubtradeChannelFilter
        fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token')).access}`,
            })
        }).then(response =>
            response.blob().then(blob => {
                var today = new Date()
                let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                let time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.href = url;
                a.download = "channel_category_" + date + "_" + time + ".csv";
                a.click();
            })
        );
    }
    const getHomeOOHFilter = (homeIDs) => {
        //Getting User Selected Data By State/User Action
        let selectedHomeIDs = homeIDs !== null ? homeIDs : selectedHomeOOHList
        let selectedHomeFilter = ""
        if (selectedHomeIDs.length !== 0) {
            selectedHomeFilter = `&selected_home_ooh=${createStringFromObjectList(selectedHomeIDs)}`
        }
        return selectedHomeFilter
    }

    const getTradeChannelFilter = (tradeIDs) => {
        //Getting User Selected Data By State/User Action
        let selectedTradeChannelIDs = tradeIDs !== null ? tradeIDs : selectedTradeChannelList
        let selectedTradeChannelFilter = ""
        if (selectedTradeChannelIDs.length !== 0) {
            selectedTradeChannelFilter = `&selected_trade_channel_ch3=${createStringFromObjectList(selectedTradeChannelIDs)}`
        }
        return selectedTradeChannelFilter
    }

    const getSubtradeChannelFilter = (subIDs) => {
        //Getting User Selected Data By State/User Action
        let selectedSubtradeChannelIDs = subIDs !== null ? subIDs : selectedSubtradeChannelList
        let selectedSubtradeChannelFilter = ""
        if (selectedSubtradeChannelIDs.length !== 0) {
            selectedSubtradeChannelFilter = `&selected_subtrade_channel_ch4=${createStringFromObjectList(selectedSubtradeChannelIDs)}`
        }
        return selectedSubtradeChannelFilter
    }

    const loadHomeOOHList = async (tradeIDs = selectedTradeChannelList, subIDs = selectedSubtradeChannelList) => {
        //Trade Channel filter
        let selectedTradeChannelFilter = getTradeChannelFilter(tradeIDs)
        //Subtrade Channel Filter
        let selectedSubtradeChannelFilter = getSubtradeChannelFilter(subIDs)

        let url = BASE_URL + INPUT_FORMS + MFA + CHANNEL_CATEGORY_MAPPINGS + FILTERS + `?selected_form=${props.formId}` + `&filter_type=home_ooh` + selectedTradeChannelFilter + selectedSubtradeChannelFilter
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else {
            if (response.results.length > 0) {
                setHomeOOHList(response.results);
            }
        }
    }

    //AJAX Call To Load Category SAP List
    const loadTradeChannelList = async (homeIDs = selectedHomeOOHList, subIDs = selectedSubtradeChannelList) => {
        //Home OOH Channel filter
        let selectedHomeFilter = getHomeOOHFilter(homeIDs)
        //Subtrade Channel filter
        let selectedSubtradeChannelFilter = getSubtradeChannelFilter(subIDs);

        let url = BASE_URL + INPUT_FORMS + MFA + CHANNEL_CATEGORY_MAPPINGS + FILTERS + `?selected_form=${props.formId}` + `&filter_type=trade_channel_ch3` + selectedHomeFilter + selectedSubtradeChannelFilter
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else {
            if (response.results.length > 0) {
                setTradeChannelList(response.results);
            }
        }
    }
    const loadSubtradeChannelList = async (homeIDs = selectedHomeOOHList, tradeIDs = selectedTradeChannelList) => {
        //Home OOH Channel filter
        let selectedHomeFilter = getHomeOOHFilter(homeIDs);
        //Trade Channel Filter
        let selectedTradeChannelFilter = getTradeChannelFilter(tradeIDs)

        let url = BASE_URL + INPUT_FORMS + MFA + CHANNEL_CATEGORY_MAPPINGS + FILTERS + `?selected_form=${props.formId}` + `&filter_type=subtrade_channel_ch4` + selectedHomeFilter + selectedTradeChannelFilter
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand Category Mapping List API", response.results.message)
        } else {
            if (response.results.length > 0) {
                setSubtradeChanelList(response.results);
            }
        }
    }

    const loadChannelCategoryMappingList = async (useTimer, homeIDs, tradeIDs, subIDs) => {
        let selectedHomeFilter = getHomeOOHFilter(homeIDs)

        let selectedTradeChannelFilter = getTradeChannelFilter(tradeIDs)

        let selectedSubtradeChannelFilter = getSubtradeChannelFilter(subIDs)

        //Clearing Timeout Before Adding New Timeout(Previous Timeout)
        if (dropDownTimer) {
            clearTimeout(dropDownTimer);
        }
        //Add Timeout Before Hitting API
        if (useTimer) {
            setDropDownTimer(
                setTimeout(function () {
                    // loadBrandCategoryMappingAPICall(selectedBrandFilter, selectedSummarizedBrandFilter, selectedCategorySAPFilter);
                    toast.promise(loadChannelCategoryMappingAPICall(selectedHomeFilter, selectedTradeChannelFilter, selectedSubtradeChannelFilter), {
                        loading: "Loading. wait a moment!",
                        success: 'Data load success.',
                        error: 'Something went wrong.',
                    },
                        {
                            position: 'top-center',
                            className: 'toast-popup',
                        });
                }, 1500)
            )
        } else {
            loadChannelCategoryMappingAPICall();
        }
    }

    const setDropDownValues = (objs, valueType) => {
        if (valueType === "Home ooh") {
            setSelectedHomeOOHList(objs)
            //To load relevent values in other dropdown filters
            loadTradeChannelList(objs, selectedSubtradeChannelList);
            loadSubtradeChannelList(objs, selectedTradeChannelList);
        }
        else if (valueType === "Trade Channel ch3") {
            setSelectedTradeChannelList(objs)
            //To load relevent values in other dropdown filters
            loadHomeOOHList(objs, selectedSubtradeChannelList);
            loadSubtradeChannelList(selectedHomeOOHList, objs);
        }
        else if (valueType === "Subtrade Channel ch4") {
            setSelectedSubtradeChannelList(objs)
            //To load relevent values in other dropdown filters
            loadHomeOOHList(selectedTradeChannelList, objs);
            loadTradeChannelList(selectedHomeOOHList, objs);
        }
        //Loading Channel Mapping List In Table
        loadChannelMappingsBasedOnFilters(objs, valueType);
    }


    const loadChannelMappingsBasedOnFilters = (objs, valueType) => {
        //Loading Channel Mapping Values which is dependent on Home OOH Dropdown
        if (valueType === "Home ooh") {
            loadChannelCategoryMappingList(true, objs, selectedTradeChannelList, selectedSubtradeChannelList);
        }
        //Loading Channel Mapping Values which is dependent on Trade Channel Dropdown
        if (valueType === "Trade Channel ch3") {
            loadChannelCategoryMappingList(true, selectedHomeOOHList, objs, selectedSubtradeChannelList);
        }
        //Loading Channel Mapping Values which is dependent on Subtrade Channel Dropdown
        if (valueType === "Subtrade Channel ch4") {
            loadChannelCategoryMappingList(true, selectedHomeOOHList, selectedTradeChannelList, objs);
        }
    }

    const handleEditClickInParent = (id) => {
        setIsFormModalOpen(true)
        setSelectedIdToEdit(id)
    }

    const postSubmitAndEditData = () => {
        loadChannelCategoryMappingList(true, selectedHomeOOHList, selectedTradeChannelList, selectedSubtradeChannelList);
    }

    //useEffect Method
    useEffect(() => {
        let mounted = true
        if (mounted) {
            loadHomeOOHList()
            loadTradeChannelList()
            loadSubtradeChannelList()
            loadChannelSuggestion()
            loadChannelCategoryMappingList(false, selectedHomeOOHList, selectedTradeChannelList, selectedSubtradeChannelList);
        }
        return function cleanup() {
            mounted = false
        }

    }, [])

    return (
        <div className="user-view-container">
            <div className="brand-category-header-container row">
                <div className="col-10 brand-category-filter-container">
                    <div className="brand-category-dropdown-container">
                        <DropDownMultiSelectMFACustom title="Home ooh" options={homeOOHList} setParentDropdownValue={setDropDownValues} />
                    </div>
                    <div className="brand-category-dropdown-container">
                        <DropDownMultiSelectMFACustom title="Trade Channel ch3" options={tradeChannelList} setParentDropdownValue={setDropDownValues} />
                    </div>
                    <div className="brand-category-dropdown-container">
                        <DropDownMultiSelectMFACustom title="Subtrade Channel ch4" options={subtradeChannelList} setParentDropdownValue={setDropDownValues} />
                    </div>
                </div>
                {props.adminIds.includes(props.formId) ?
                    (<div className="col-2 brand-category-add-delete-export-button-container">
                        <button className="brand-category-export-button mt-3 col" type="button" value="Export Data" onClick={handleExportButton}>Export</button>

                        {selectedList.length === 0 ?
                             <button className="brand-category-button mt-3 col" type="button" value="+ Add New" onClick={() => handleIsFormModalOpen(true)}><FontAwesomeIcon icon={faPlus} className="search-icon" size="1x" /> Add New</button>
                            : <button className="brand-category-button mt-3 col" type="button" value="Delete" onClick={handleDeleteButton}><FontAwesomeIcon icon={faTrash} className="search-icon" size="1x" /> Delete</button>}
                    </div>) : ""}
            </div>
            <div className="brand-category-body">
                <div className='other-mfa-table-holder'>
                    <div className='channel-category-chips-container'>
                            {/* CSS Purpose */}
                    </div>
                    {/* Loader(While Data Loading) */}
                    {loading ? <div className="table-data-note"><Spinner animation="border" />
                        <p></p>
                    </div> : ""}
                    {/* Loader(While Data Loading) */}
                    {channelCategoryMappingList.length > 0 ?
                        <div className="brand-category-table-container">
                            <TableMFAChannelCategory columns={columns}
                                channelCategoryMappingList={channelCategoryMappingList}
                                setSelectedListInParent={setSelectedListInParent}
                                handleEditClickInParent={handleEditClickInParent}
                                formId={props.formId} adminIds={adminIds} />
                        </div>
                        : ''}
                    {/* No Data Message */}
                    {channelCategoryMappingList.length === 0 && loading === false ? (<div className="table-data-note"><p>No data found.</p>
                        <p></p>
                    </div>) : ""}
                    {/* No Data Message */}
                </div>

            </div>
            {/* Loader */}
            <Toaster />
            {/* Loader */}
            {isFormModalOpen ?
                <ChannelCategoryFormModal isFormModalOpen={isFormModalOpen} handleIsFormModalOpen={handleIsFormModalOpen}
                    formId={props.formId} selectedIdToEdit={selectedIdToEdit} suggestions={suggestions}
                    postSubmitAndEditData={postSubmitAndEditData}
                />
                : ""}
            {/* Message Dialogue Box */}
            {openDeleteDialogueBox ? <BrandCategoryDialogueBox openDialogueBox={openDeleteDialogueBox}
                handleDeleteDialogueBox={handleDeleteDialogueBox}
                messageType="Delete"
                message="Are you sure you want to delete this Channel"
                handleDelete={handleDelete} /> : ""}
            {/* Message Dialogue Box */}

        </div>
    );

};

export default Consolidated3;